export default __webpack_public_path__ + "static/media/GA_ReSynth-3.860524c8.wav";